export const ROOT_PATH = '/';
export const ADMIN_PATH = 'admin/';
export const LOGIN_PATH = '/login';

interface PathInfo {
  [key: string]: { pathName: string; name: string };
}

export const pathURL: PathInfo = {
  QUOTATION_LIST: {
    pathName: ROOT_PATH,
    name: '見積一覧',
  },
  QUOTATION_INPUT: {
    pathName: `${ROOT_PATH}quotation-input`,
    name: '見積入力',
  },
  ADMIN_CONSOLE: {
    pathName: `${ROOT_PATH}${ADMIN_PATH}console`,
    name: '管理メニュー',
  },
  MST_USER: {
    pathName: `${ROOT_PATH}${ADMIN_PATH}mst-user`,
    name: 'ユーザー管理',
  },
  MST_HINMEI: {
    pathName: `${ROOT_PATH}${ADMIN_PATH}mst-hinmei`,
    name: '品名管理',
  },
  MST_OFFICE: {
    pathName: `${ROOT_PATH}${ADMIN_PATH}mst-office`,
    name: '拠点管理',
  },
  MST_SALE_FLOW: {
    pathName: `${ROOT_PATH}${ADMIN_PATH}mst-sale-flow`,
    name: '商流管理',
  },
  MST_NET_RATE: {
    pathName: `${ROOT_PATH}${ADMIN_PATH}mst-net-rate`,
    name: '仕切率管理',
  },
  MST_CONTRACT_PERIOD: {
    pathName: `${ROOT_PATH}${ADMIN_PATH}mst-contract-period`,
    name: '契約年数管理',
  },
  MST_PRODUCT: {
    pathName: `${ROOT_PATH}${ADMIN_PATH}mst-product`,
    name: '製品区分管理',
  },
  MST_RELATION: {
    pathName: `${ROOT_PATH}${ADMIN_PATH}mst-relation`,
    name: '品名情報紐づけ管理',
  },
  MST_REMARKS: {
    pathName: `${ROOT_PATH}${ADMIN_PATH}mst-remarks`,
    name: '品名情報紐づけ管理',
  },
  MST_CONTROL_RULE: {
    pathName: `${ROOT_PATH}${ADMIN_PATH}mst-control-rule`,
    name: '制御ルール管理',
  },
};

export const rowTableColor = {
  [1 as number]: 'bg-[#deeaf6]',
  [2 as number]: 'bg-[#fbe4d5]',
  [3 as number]: 'bg-[#ececec]',
  [4 as number]: 'bg-[#fef2cb]',
  [5 as number]: 'bg-[#bfbfbf]',
  [9 as number]: 'bg-[#ccccff]',
};
